import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4998 4.16663V15.8333M4.6665 9.99996H16.3332",
		stroke: "currentColor",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAddIcon;
